var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnorderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08529 4.75716H12.752M7.08529 8.75716H12.752M7.08529 12.7572H12.752M4.91862 4.75716C4.91862 4.94126 4.76938 5.09049 4.58529 5.09049C4.40119 5.09049 4.25195 4.94126 4.25195 4.75716C4.25195 4.57307 4.40119 4.42383 4.58529 4.42383C4.76938 4.42383 4.91862 4.57307 4.91862 4.75716ZM4.91862 8.75716C4.91862 8.94126 4.76938 9.09049 4.58529 9.09049C4.40119 9.09049 4.25195 8.94126 4.25195 8.75716C4.25195 8.57307 4.40119 8.42383 4.58529 8.42383C4.76938 8.42383 4.91862 8.57307 4.91862 8.75716ZM4.91862 12.7572C4.91862 12.9413 4.76938 13.0905 4.58529 13.0905C4.40119 13.0905 4.25195 12.9413 4.25195 12.7572C4.25195 12.5731 4.40119 12.4238 4.58529 12.4238C4.76938 12.4238 4.91862 12.5731 4.91862 12.7572Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnorderedList);
export default __webpack_public_path__ + "static/media/unordered-list.11cd3d6a74444ae629dce9778dc1eeb9.svg";
export { ForwardRef as ReactComponent };